module.exports = function() {
  return new Worker(__webpack_public_path__ + "1234105da06b9bc849c0.worker.js");
};